import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }

import { CircleCheck, CircleX } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'IconsCheck',
  props: {
  isValid: {
    type: Boolean,
    required: true,
  },
  size: {
    type: Number,
    default: 16,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isValid)
      ? (_openBlock(), _createBlock(_unref(CircleCheck), {
          key: 0,
          class: "text-green-600",
          size: __props.size
        }, null, 8, ["size"]))
      : (_openBlock(), _createBlock(_unref(CircleX), {
          key: 1,
          class: "text-red-500",
          size: __props.size
        }, null, 8, ["size"]))
  ]))
}
}

})